import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import EssentialLayout from "@/components/menu-management/manage-essential/essential-layout";
import { Card } from "@/components/ui/card";
import { TabsList, Tabs, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import CetagoryTabs from "@/components/menu-management/manage-essential/essential-drinks/category/cetagory-tabs";
import AddOnsTabs from "@/components/menu-management/manage-essential/essential-drinks/addons/addons-tabs";
import AllergenTabs from "@/components/menu-management/manage-essential/essential-drinks/allergen/allergen-tabs";
import BaseTabs from "@/components/menu-management/manage-essential/essential-pizza/base/base-tabs";
import CrustTabs from "@/components/menu-management/manage-essential/essential-pizza/crust/crust-tabs";
import TroppingsTabs from "@/components/menu-management/manage-essential/essential-pizza/toppings/toppings-tabs";
import ModifiersTabs from "@/components/menu-management/manage-essential/essential-drinks/modifiers/modifiers-tabs";
import { useParams } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import { useMemo, useState } from "react";
import { useFetchAllMenuData } from "@/hooks/use-fetch-all-menu-data";
import EssentialSkeleton from "@/components/skeleton/essential-skeleton";

function EssentialPizza() {
  const { id } = useParams();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("cetagoris");

  const fetchOnly = useMemo(() => {
    switch (activeTab) {
      case "cetagoris":
        return ["categories"];
      case "base":
        return ["bases"];
      case "crust":
        return ["crusts"];
      case "troppings":
        return ["toppings"];
      case "add-ons":
        return ["addOns"];
      case "allergen":
        return ["allergens"];
      case "modifiers":
        return ["modifiers"];
      default:
        return ["categories"];
    }
  }, [activeTab]);

  const { groupLoading } = useFetchAllMenuData(user?.restaurant_id, id, {
    fetchOnly,
  });

  if (groupLoading) return <EssentialSkeleton />;
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <EssentialLayout>
        <Card className="bg-transparent col-span-1 md:col-span-2">
          <Tabs
            valueKey="essential-pizza"
            className="bg-transparent relative"
            defaultValue="cetagoris"
            onValueChange={setActiveTab}
          >
            <TabsList className="flex justify-start">
              <Separator className="absolute top-8" />
              <TabsTrigger className="bg-transparent" value="cetagoris">
                Categories
              </TabsTrigger>
              <TabsTrigger value="base">Base</TabsTrigger>
              <TabsTrigger value="crust">Crust</TabsTrigger>
              <TabsTrigger value="troppings">Toppings</TabsTrigger>
              <TabsTrigger value="add-ons">Add-ons</TabsTrigger>
              <TabsTrigger value="allergen">Allergens</TabsTrigger>
              <TabsTrigger value="modifiers">Modifiers</TabsTrigger>
            </TabsList>
            <CetagoryTabs />
            <BaseTabs />
            <CrustTabs />
            <TroppingsTabs />
            <AddOnsTabs />
            <AllergenTabs />
            <ModifiersTabs />
          </Tabs>
        </Card>
      </EssentialLayout>
    </Layout2>
  );
}

export default EssentialPizza;
